/* eslint-disable max-classes-per-file */

export class ExpirePaymentDatePresenter {
  hours: number;

  seconds: number;

  minute: number;

  dateTime: string;

  time: string;

  date: string;

  isExpire: boolean;

  constructor(data: any) {
    this.hours = data?.hours || 0;
    this.seconds = data?.seconds || 0;
    this.minute = data?.minute || 0;
    this.dateTime = data?.dateTime || "";
    this.time = data?.time || "";
    this.date = data?.date || "";
    this.isExpire = data?.isExpire || false;
  }
}
export class PaymentBookingPresenter {
  isPostpaid: boolean;

  cardType: string;

  cardBooking: string;

  cardNo: string;

  paymentGatewayId: string;

  moreDetail: string;

  paymentIcon: string;

  serviceProvider: string;

  labelMethod: string;

  constructor(data: any) {
    this.isPostpaid = data?.isPostpaid || false;
    this.cardType = data?.cardType || "";
    this.cardBooking = data?.cardBooking || "";
    this.cardNo = data?.cardNo || "";
    this.paymentGatewayId = data?.paymentGatewayId || "";
    this.moreDetail = (data?.moreDetail || "").toLocaleLowerCase();
    this.paymentIcon = data?.paymentIcon || "";
    this.serviceProvider = data?.serviceProvider || "";
    this.labelMethod = data?.labelMethod || "";
  }
}

export class RePaymentPresenter {
  paymentType: string;

  paymentUrl: string;

  isPaymentExpire: boolean;

  isAllocatesExpire: boolean;

  expireAllocateDate: ExpirePaymentDatePresenter;

  expirePaymentDate: ExpirePaymentDatePresenter;

  paymentSuccessDate: string;

  constructor(data: any) {
    this.paymentType = data?.paymentType || "";
    this.paymentUrl = data?.paymentUrl || "";
    this.isPaymentExpire = data?.isPaymentExpire || false;
    this.isAllocatesExpire = data?.isAllocatesExpire || false;
    this.expireAllocateDate = new ExpirePaymentDatePresenter(
      data?.expireAllocateDate,
    );
    this.expirePaymentDate = new ExpirePaymentDatePresenter(
      data?.expirePaymentDate,
    );
    this.paymentSuccessDate = data?.paymentSuccessDate || "";
  }
}
export class ContactDatePresenter {
  title: string;

  firstname: string;

  lastname: string;

  countryOfPassport: number;

  email: string;

  phone: string;

  countryOfPassportName: string;

  prefixPhone: string;

  phoneNumber: string;

  constructor(data: any) {
    this.title = data?.title || "";
    this.firstname = (data?.firstname ?? data?.firstName) || "";
    this.lastname = (data?.lastname ?? data?.lastName) || "";
    this.countryOfPassport = data?.countryOfPassport || 0;
    this.email = data?.email || "";
    this.phone = data?.phone || "";
    this.countryOfPassportName = data?.countryOfPassportName || "";
    this.prefixPhone = data?.prefixPhone || "";
    this.phoneNumber = data?.phoneNumber || "";
  }
}

export class ResponseCommonPresenter {
  status: boolean;

  message: string;

  data: [];

  constructor(response: any) {
    this.status = response?.status || "";
    this.message = response?.message || "";
    this.data = [];
  }
}

export class DayPlanDataPresenter {
  day: number;

  plan: string;

  constructor(response: any) {
    this.day = response?.day || 0;
    this.plan = response?.plan || "";
  }
}

export class PaymentChannelDataPresenter {
  cardBooking: string;

  cardType: string;

  cardNo: string;

  paymentGatewayId: string;

  moreDetail: string;

  serviceProvider: string;

  paymentIcon: string;

  labelMethod: string;

  gotherCash: number;

  paymentFee: number;

  constructor(response: any) {
    this.cardBooking = response?.cardBooking || "";
    this.cardType = response?.cardType || "";
    this.cardNo = response?.cardNo || "";
    this.paymentGatewayId = response?.paymentGatewayId || "";
    this.moreDetail = response?.moreDetail || "";
    this.serviceProvider = response?.serviceProvider || "";
    this.paymentIcon = response?.paymentIcon || "";
    this.labelMethod = response?.labelMethod || "";
    this.gotherCash = response?.gotherCash || 0;
    this.paymentFee = response?.paymentFee || 0;
  }
}

class PaymentCouponDiscountList {
  count: number;

  total: number;

  list: { code: string; amount: number }[];

  constructor(response: any) {
    this.count = response?.count || 0;
    this.total = response?.total || 0;
    this.list = (response?.list || []).map((val: any) => {
      return { code: val?.code || "", amount: val?.amount || 0 };
    });
  }
}

export class PaymentCouponDiscountPresenter {
  totalDiscount: number;

  voucher: PaymentCouponDiscountList;

  coupon: PaymentCouponDiscountList;

  gotherDiscount: PaymentCouponDiscountList;

  constructor(response: any) {
    this.totalDiscount = response?.totalDiscount || 0;
    this.voucher = new PaymentCouponDiscountList(response?.voucher);
    this.coupon = new PaymentCouponDiscountList(response?.coupon);
    this.gotherDiscount = new PaymentCouponDiscountList(
      response?.gotherDiscount,
    );
  }
}

export class ListStepDataPresenter<T = unknown> {
  type: string;

  step: string;

  count: number;

  data: T;

  constructor(response: any, dataMapper?: (data: any) => T) {
    this.type = response?.type || "";
    this.step = response?.step || "";
    this.count = response?.count || 0;
    this.data = dataMapper
      ? dataMapper(response?.data)
      : response?.data || null;
  }
}

export class RefundedPaymentDatePresenter {
  bookingInternalNo: string;

  amount: number;

  refundToCustomerDateOri: string;

  refundToCustomerDate: string;

  refundProcessDay: number;

  refundStatus: string;

  currency: string;

  updatedAt: string;

  constructor(data: any) {
    this.bookingInternalNo = data?.bookingInternalNo || "";
    this.amount = data?.amount || 0;
    this.refundToCustomerDateOri = data?.refundToCustomerDateOri || "";
    this.refundToCustomerDate = data?.refundToCustomerDate || "";
    this.refundProcessDay = data?.refundProcessDay || "";
    this.refundStatus = data?.refundStatus || "";
    this.currency = data?.currency || "";
    this.updatedAt = data?.updatedAt || "";
  }
}
